<template>
  <v-input :rules="rules" :value="editorContent" :label="label" :disabled="disabled" class='amazeEditorHtml py-3'>
    <vue-editor
      v-model="editorContent"
      :editorToolbar="customToolbar"
      :disabled="disabled"
      @text-change="onEditorChange"
    ></vue-editor>
  </v-input>
</template>

<style lang="scss" scoped>
::v-deep {
  .v-label.error--text{
    color: #ff5252 !important;
  }
  .v-input__slot{
    display:block;
  }
  label {
    font-size: 15px;
    margin-bottom: 10px;

  }
}
</style>

<script>
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  props: ['value', 'rules', 'label', 'disabled'],

  data() {
    return {
      editorContent: this.value,
      editorDisabled: false,
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "link"],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ list: "ordered" }, { list: "bullet" }],
        ['clean']
      ]
    }
  },
  methods: {
    onEditorChange() {
      this.$emit('input', this.editorContent);
    }
  },
  watch: {
    value(newValue) {
      this.editorContent = newValue;
    },
    disabled(newValue) {
      this.editorDisabled = newValue;
    },
    rules(newValue) {
      this.rules = newValue;
    }
  }
}
</script>
